export default __webpack_public_path__ + "10f4844f47638ee50a58a349010820ef.svg";